/** True when SI should show the premium plan badge (any paid / operational plan). */
export function isPremiumPlanName(planName) {
  if (!planName) {
    return false;
  }
  return String(planName).trim().toLowerCase() !== "basic";
}

export function normalizeActivePlanResponse(apiPayload) {
  if (!apiPayload) {
    return null;
  }
  const planName =
    apiPayload.plan_name ||
    apiPayload.data?.plan_name ||
    apiPayload.planName ||
    null;
  return {
    plan_name: planName,
    is_premium:
      apiPayload.is_premium ??
      apiPayload.data?.is_premium ??
      isPremiumPlanName(planName),
  };
}
